// extracted by mini-css-extract-plugin
export default {"mainContent":"src__mainContent--NjlVpOZ"};